import { Typography, Box, Stack, Button, LinearProgress } from "@mui/material";
import { useForm } from "../../../providers/FormProvider";
import { makeStyles } from "tss-react/mui";
import Scrollbar from "../../common/core/Scrollbar";
import { Helmet } from "react-helmet-async";
import MissionTypeSection from "./sections/MissionTypeSection";
import ContactSection from "./sections/ContactSection";
import TargetSection from "./sections/TargetSection";
import RouteSection from "./sections/RouteSection";
import ExtraDetailsSection from "./sections/ExtraDetailsSection";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: "100%",
      height: "100%",
      position: "absolute",
    },
    progessBar: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      zIndex: 999
    },
    scrollbar: {
      width: "100%",
      height: "100%",
      position: "absolute"
    },
    content: {
      position: "relative",
      minHeight: "100%",
      height: "auto",
      maxWidth: "100%",
      width: "570px",
      marginLeft: "auto",
      marginRight: "auto",
      padding: theme.spacing(1.5),
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(14),
    },
    logo: {
      height: "64px",
      width: "auto",
      borderRadius: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  })
);

export default function AdvancedFormPage() {
  const { classes } = useStyles();
  const { form, submitForm, canSubmit, submitting } = useForm();
  const { t } = useTranslation();

  return (
    <Box className={classes.root}>

      {submitting ? (
        <LinearProgress variant="indeterminate" className={classes.progessBar} />
      ) : null}

      <Helmet>
        <title>{form.header || "Assist Forms"}</title>
      </Helmet>

      <Scrollbar className={classes.scrollbar}>
        <Stack className={classes.content} justifyContent="flex-start" alignItems="flex-start" alignContent="flex-start" spacing={3}>

          <Box>
            <img src={form.stationLogo || "/assets/icons/black192.png"} className={classes.logo} />
            <Typography variant="h4">{form.header || t("advancedForm:header")}</Typography>
            <Typography variant="body1">{form.message || ""}</Typography>
          </Box>

          <MissionTypeSection />

          <ContactSection />

          <TargetSection />

          <RouteSection />

          <ExtraDetailsSection />

          <Box>
            <Button variant="contained" color="primary" onClick={submitForm} disabled={!canSubmit} loading={submitting}>
              {t("common:send")}
            </Button>
          </Box>

        </Stack>
      </Scrollbar>
    </Box>
  );
}
